"use client";

import React, { useEffect } from "react";
import { ConfigProvider } from "antd-mobile";
import enUS from "antd-mobile/es/locales/en-US";
import { QueryClientProvider } from "react-query";
import { queryClient } from "@/utils/query-client";
import PageEntryTracker from "@/components/PageEntryTracker";
import { useEruda } from "@/hooks/useEruda";
import { useUserStore } from "@/store/user";

interface RootProviderProps {
  children: React.ReactNode;
}

const RootProvider: React.FC<RootProviderProps> = ({ children }) => {
  const fetchUserInfo = useUserStore((state) => state.fetchUserInfo);

  useEffect(() => {
    fetchUserInfo();
  }, [fetchUserInfo]);

  useEruda();

  return (
    <ConfigProvider locale={enUS}>
      <QueryClientProvider client={queryClient}>
        <PageEntryTracker />
        {children}
      </QueryClientProvider>
    </ConfigProvider>
  );
};

export default RootProvider;
